import {
  PREMIUM_MIN_PHOTO_SIZE,
  ROUTE_URL,
} from "../../components/common/const";

export default {
  specialist: {
    pageTitle: "Area & Condo Specialist",
    searchByAgent: "Search by agent",
    searchByAgentDescription: "Search by agent ID or name",
    searchByAreaOrCondo: "Search by area or condo",
    searchByAreaOrCondoDescription:
      "Search by township, state, city or building name",
    specialistId: "Specialist ID",
    id: "Agent ID",
    agentName: "Agent name",
    status: "Status",
    building: "Building name",
    city: "City",
    state: "State",
    categoryType: "Category type",
    startDate: "Start date",
    endDate: "End date",
    duration: "Duration",
    action: "Action",
    premiumUpgrade: "Premium balance",
    subscription: "Subscription",
    sorting: {
      "new-to-old": "Latest start date",
      "old-to-new": "Oldest start date",
      "end_date_new-to-old": "Latest end date",
      "end_date_old-to-new": "Oldest end date",
    },
    filter: {
      statusCode: "Specialist status",
      propertyGroupTypeCode: "Category",
      notFound: {
        heading: "We couldn't find any specialist that match your refinements.",
        subHeading:
          "Try changing your criteria to find the specialist you are after.",
      },
    },
    btnNew: "Add new specialist",
    form: {
      addTitle: "Add new specialist",
      type: "Type of specialist",
      userId: {
        field: "Agent name or REA ID",
        placeholder: "Search agent name or input REA ID",
      },
      profilePhoto: {
        field: "Profile photo",
        placeholder:
          "This profile photo will automatically synced from the agent’s profile photo.",
      },
      locationLevel1Id: {
        field: "State",
        placeholder: "Select one",
      },
      locationLevel2Id: {
        field: "City",
        placeholder: "eg. Cheras",
        notFound: "The name is not a valid city",
      },
      buildingId: {
        field: "Building name",
        placeholder: "Search building name",
        notFound: "The name is not a valid building",
      },
      propertyGroupType: {
        field: "Category type",
        placeholder: "Select one",
      },
      durationMonth: "Package duration (month)",
    },
    "area specialist": "Area Specialist",
    "condo specialist": "Condo Specialist",
    back: "Back",
    save: "Add",
    returnTop: "Return to the top of the result",
    error: {
      AGENT_MUST_HAS_PROFILE_PHOTO: "This agent do not have a profile photo.",
      AGENT_MUST_HAS_ONLINE_LISTING:
        "This agent do not have minimum 1 listing.",
      AGENT_MUST_HAS_LICENSE_NO: "This agent do not have a license number.",
      SPECIALIST_DUPLICATE:
        "Agent has an Active subscription in this Area /Condo. Please try again after the current subscription is Expired.",
      INVALID_AGENT_STATUS: "This agent status is inactive.",
      SPECIALIST_SLOT_FULL:
        "Oops, sorry the slots are full for the area/condo selected. Please try again another day.",
      modal: {
        title: "Agent does not have enough {product} listings",
        content:
          "We will send a notification to the agent to upgrade at least <strong>{listingNumber} listings within 14 days of time</strong>. Are you sure to proceed?",
      },
    },
    success: {
      description: "Your area/condo specialist is now published.",
      back: "Back to main page",
      tips: "All done!",
    },
    updateAction: {
      ACTIVATE: {
        button: "Activate",
        success: "{agentName} specialist status has been activated.",
      },
      DELETE: {
        button: "Delete",
        success: "The agent has been deleted permanently.",
        modal: {
          title: "Are you sure you want to delete?",
          content:
            "Once you delete the agent, it will be permanently removed and cannot be restored.",
        },
      },
      OFFLINE: {
        button: "Offline",
        success: "{agentName} specialist status has been offlined.",
      },
    },
  },
  specialistSlot: {
    title: "Define slots",
    subTitle: "Define slots for area and condo specialist",
    back: "Back",
    type: "Specialist type",
    propertyGroupType: "Category type",
    slotNumber: "Slot number",
    productGroup: "Listing tier",
    listingNumber: "Listing number",
    updatedDate: "Date updated",
    provisionTotal: "Premium listing",
    action: "Action",
    emptyHeader: "No slots found",
    save: "Save changes",
    form: {
      type: "Type of specialist",
      propertyGroupType: "Category type",
      slotNumber: "Number of slots",
      productGroup: "Listing tier",
      listingNumber: "Number of active listings",
      updatedDate: "Date updated",
      provisionTotal: "Premium listing",
    },
    success: {
      description: "Your area/condo specialist slots is now updated.",
      back: "Back to main page",
      tips: "All done!",
    },
  },
  specialistReport: {
    title: "Specialist Report",
    subTitle: "Performance details",
    areaSpecialist: "Area Specialist",
    condoSpecialist: "Condo Specialist",
    searchByAgent: "Search by agent",
    searchByAgentDescription: "Search by agent ID or name",
    searchByAreaOrCondo: "Search by area or condo",
    searchByAreaOrCondoDescription:
      "Search by township, state, city or building name",
    startDate: "Start date",
    statusCode: "Specialist status",
    propertyGroupTypeCode: "Category",
    returnTop: "Return to the top of results",
    table: {
      id: "Agent ID",
      status: "Status",
      agentName: "Agent name",
      city: "City",
      state: "State",
      building: "Building name",
      categoryType: "Category type",
      startDate: "Start date",
      duration: "Duration",
      impressions: "Impressions",
      clicks: "Clicks",
      enquiries: "Enquiries",
    },
    createReport: {
      button: "Create Report",
      title:
        "{reportStatusCode, plural, =3 {The excel file is generated} =2 {Your request to create the excel file is still in progress} =1 {Your request to create the excel file is still in progress} =0 {Do you want to create the excel file?} other {Sorry, something went wrong}}",
      content:
        "{reportStatusCode, plural, =3 {The file download link will be sent to your email, {email}. Please contact our customer service if you do not receive the email or face issues downloading the file.} =2 {Rest assured that once the file is ready, we will send the file download link to your email.} =1 {Rest assured that once the file is ready, we will send the file download link to your email.} =0 {Preparing the excel file might take a while. Once it is ready, we will send the file download link to your email, {email}. Please contact our customer service if you did not receive the email or face issues downloading the file.} other {Please speak with your office administration.}}",
      ok: "{reportStatusCode, plural, =0 {Create} other {Got it}}",
      cancel: "Cancel",
    },
  },
  specialistSelfServe: {
    pageTitle: "Area & Condo Specialist",
    pageDescription:
      "Reach more relevant property seekers by being recognized as a Specialist in your area/condo today!",
    btnNew: "Book Specialist",
    tabTitle: "Area & Condo Specialist packages",
    sortTitle: "Sort",
    returnTop: "Back to the top",
    recommendedTitle: "Recommended residential for you",
    impressions: "Impressions",
    pageViews: "Page views",
    enquiries: "Enquiries",
    premiumBalance: "Premium Balance",
    type: {
      1: "Condo Specialist",
      2: "Area Specialist",
    },
    btnBookNow: "Book now",
    dataNotFound: "No {type, plural, =1 {Condo} =2 {Area}} Specialist found",
    premiumUpgradeTooltip:
      "1 Premium listing will be credited to your account upon activation date on a monthly basis throughout your Specialist duration. Please redeem and activate as each credit will expire in 1 month from credited date.",
    activeListing: "Active Listings",
    slotAvailable: "Slots Available",
    priceFrom: "Price From",
    btnRedeem: "Redeem",
    btnExtend: "Extend",
    reporting: "Reporting",
    help: "Help",
    recommendationOnboarding: {
      title: "Don’t miss the opportunity!",
      content:
        "Get recognized as a Specialist in your area/condo today by clicking ‘Book now’!",
    },
    dashboardAlert: {
      pleaseNote: "Please note:",
      SPECIALIST_SUSPENDED:
        "1 or more of your Specialist packages have been suspended.",
      AGENT_MUST_HAS_ONLINE_LISTING:
        "A minimum of 1 listing is required for the Area/Condo you specialize in.",
      AGENT_MUST_HAS_PROFILE_PHOTO:
        "Profile picture is required to qualify as a Specialist.",
      AGENT_MUST_HAS_LICENSE_NO:
        "An agent license number is required to qualify as a Specialist.",
      AGENT_MUST_HAS_PROFILE_PHOTO_LICENSE_NO:
        "Profile picture or license number is required to qualify as a Specialist.",
      INSUFFICIENT_ONLINE_PRODUCT_LISTING:
        "Upgrade your listing to minimum {productCount} {productDescription} listings to continue with the Specialist package.",
      SPECIALIST_DUPLICATE_1:
        "You have an existing Specialist subscription for the selected Area/Condo.",
      SPECIALIST_DUPLICATE_2:
        "Please select again or you can extend the existing Specialist subscription from the Area & Condo Specialist page.",
      notifyMeGeneral:
        "0 slots available. The next available slot will be on {nextAvailableSlot}. Slot bookings are on a first-come-first-served basis.",
      notifyMeNotification:
        "Sorry, all slots have been booked! Click 'Notify me' if you would like to be notified when the next slot is available on {nextAvailableSlot}; based on a first-come-first-served basis.",
      SPECIALIST_VIOLATED_EXTEND_STATE:
        "You have already extended your Specialist subscription for the selected Area/Condo.",
      INSUFFICIENT_QUOTE:
        "Sorry, you have insufficient credit to proceed. Please top-up and retry again.",
      defaultError: "Something went wrong. Please try again later.",
    },
    durationExplain:
      "[{qty}]{product} listing will be credited into your account every month throughout your Specialist duration.",
    cancel: "Cancel",
    startDate: "Start Date",
    endDate: "End Date",
    totalDeduction: "Total deductions",
    balance: "Balance: ",
    featuredCredit:
      "{credit} {currencyTypeCode, plural, =1 {Listing} =2 {Featured} =3 {Ad}} credits",
    promo: "Promo",
    notEnoughCredit: "Not enough credits for this upgrade.",
    topUpNow: ` <a href="${ROUTE_URL.creditBrickz}" target="_blank">Top up now</a>.`,
    notEnoughCreditHints:
      "* Your credits will be credited to your account shortly upon successful payment. Please refresh this page to view your latest credit balance.",
    extendModal: {
      title: "Confirm Extension",
      packageDuration: "Package duration (month)",
      extendYourAreaSpecialist: "Extend your Area Specialist package to:",
      extendYourCondoSpecialist: "Extend your Condo Specialist package to:",
      confirm: "Confirm extend",
      success:
        "Your {typeCode, plural, =1 {Condo Specialist} =2 {Area Specialist}} has been successfully extended.",
    },
    stats: {
      title: {
        "1": "Condo overview",
        "2": "Area overview",
      },
      myActiveListings: "My Active Listings",
      slotAvailable: "Slots Available",
    },
    form: {
      title: "Book Specialist",
      hints: "Limited to {slotNumber} slots for each property",
      switchTabModal: {
        title: "Are you sure you want to switch tabs?",
        content: "Changes you made may have not been saved.",
        ok: "Proceed",
      },
      confirmSpecialistModal: {
        title: "Confirm Book Specialist",
        ok: "Confirm",
        bookingDetails: "Booking details: ",
        location:
          "{location} x {month} {month, plural, =1 {month} other {months}}",
      },
      locationLevel1Id: {
        field: "State",
        placeholder: "Please select",
      },
      locationLevel2Id: {
        field: "City",
        placeholder: "eg. Cheras",
        notFound: "The name is not a valid city",
      },
      buildingId: {
        field: "Building name",
        placeholder: "Search building name",
        notFound: "The name is not a valid building",
      },
      categoryType: {
        field: "Category type",
        placeholder: "Please select",
      },
      durationMonth: "Package duration (month)",
    },
    upgradeListing: {
      title: {
        1: "Condo Specialist",
        2: "Area Specialist",
      },
      subtitle:
        "To redeem your premium listing, select only [one] Sale or Rent Listing to be upgraded to premium listing.",
      successAlert: {
        1: "Your Condo Specialist is now activated.",
        2: "Your Area Specialist is now activated.",
      },
      cancelButton: "Later",
      confirmButton: "Confirm upgrade",
      upgrade: {
        success: "Your listing has been upgraded.",
        SPECIALIST_UPGRADE_INVALID_EXPIRY_DATE:
          "Your listing has been upgraded and {listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}} has been deducted from your account.",
        SYSTEM_ERROR: "Something went wrong. Please try again later.",
        FREE_PREMIUM_UPGRADE_CREDIT_NOT_READY:
          "Your Premium balance is on it's way to you. Please refresh the page and click Redeem when it's ready.",
      },
      alert: {
        SPECIALIST_UPGRADE_EXCEED_LISTING_LIMIT: {
          title: "Alert!",
          content: "You are only allowed to select 1 listing for upgrade.",
          okButton: "OK",
        },
        SPECIALIST_UPGRADE_INVALID_PHOTO_SIZE: {
          title: "Unable to upgrade premium listing",
          content: `Please ensure your selected listing has minimum ${PREMIUM_MIN_PHOTO_SIZE} photos before you proceed with the upgrade.`,
          okButton: "Upload photo",
          cancelButton: "Cancel",
        },
        SPECIALIST_UPGRADE_INVALID_EXPIRY_DATE: {
          title: "Unable to upgrade premium listing",
          content:
            "Your selected listing is expiring soon. Upgrading will require <span style='font-weight: 600'>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</span> to extend the expiry date of your listing.",
          okButton: "Proceed",
          cancelButton: "Cancel",
        },
      },
      noListing: {
        heading: "We couldn't find any properties that match your refinements.",
        subHeading:
          "Please ensure you have active listing for the area/condo to redeem your premium listing.",
      },
    },
    creditRefundHint:
      "Cancellation of booking and refund of credits is strictly not available upon confirmation of booking.",
  },
};
